// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import querystring from 'querystring';

import React, { useContext } from 'react';
import { Redirect, Link, RouteProps } from 'react-router-dom';
import MemberContext from '../../contexts/MemberContext';
import ErrorImg from '../../assets/images/pic_error_internet.svg';
import LoginLayout from '../../layouts/LoginLayout';
import RegisterForm from './RegisterForm';
import LogoImage from '../../assets/images/login-logo.svg'
import Center from '../../components/Center';
import S from './styles';
import { getQueryParams, useQuery } from '../../lib/utility';
import { FormattedMessage, useIntl } from 'react-intl';
function getToken(hash: string) {
  return hash
    .split('&')
    .map((chunk) => {
      const split = chunk.split('=');
      return {
        [split[0].replace('#', '')]: split[1]
      };
    })
    .reduce((pre, now) => ({ ...pre, ...now }), {});
}

const RegisterFailed = (): JSX.Element => {
  const intl = useIntl();
  return (
    <LoginLayout>
      <S.FailedWrapper>
        <S.FailedImg src={ErrorImg} alt="" />
        <S.FailedDescriptionWrapper>
          <S.FailedTitle>{intl.formatMessage({ id: 'J029' })}</S.FailedTitle>
          <S.FailedDescription>
            {intl.formatMessage({ id: 'J030' })}
          </S.FailedDescription>
        </S.FailedDescriptionWrapper>
        <S.FailedRetryButton as={Link} to={'/register'}>{intl.formatMessage({ id: 'J031' })}</S.FailedRetryButton>
      </S.FailedWrapper>
    </LoginLayout>
  );
}

const Information: React.FC = () => {
  const intl = useIntl();
  return <>
    <FormattedMessage id="J020" values={{privacy: <S.Link href="/privacy" target="__blank">{intl.formatMessage({ id: 'J020-1' })}</S.Link>, terms: <S.Link href="terms" target="__blank">{intl.formatMessage({ id: 'J020-2' })}</S.Link>}}/>
  </>
}

const RegisterPage = (props: RouteProps): JSX.Element => {
  const { status } = getQueryParams(useQuery());
  const intl = useIntl();
  const member = useContext(MemberContext);
  if (member.isLogin) {
    return (
      <Redirect to="/home"></Redirect>
    )
  }
  if (props.location?.hash) {
    console.log(querystring.parse(props.location.hash));
    const token = getToken(props.location.hash);
    console.log(token);
    console.log(token.id_token);
  }
  if (status === 'failed') {
    return <RegisterFailed />
  } else {
    const information = <Information />

    return (
      <LoginLayout information={information}>
        <S.Container>
          <Center>
            <S.HeaderContainer>
              <S.Logo src={LogoImage} />
              <S.Title>{intl.formatMessage({ id: 'J012' })}</S.Title>
              <S.SubTitle>{intl.formatMessage({ id: 'J013' })}</S.SubTitle>
            </S.HeaderContainer>
          </Center>
          <S.RegisterFormContainer>
            <RegisterForm />
          </S.RegisterFormContainer>
        </S.Container>
      </LoginLayout>
    );
  }
}
export { RegisterPage as default }
